import { getProfileData as getUserProfileData } from "../api/userApi";
import { UserProfile } from "../types/types";

/**
 * Get current user profile data
 * @returns Promise<UserProfile>
 */
export async function getProfileData(): Promise<UserProfile> {
  try {
    return await getUserProfileData();
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
}

/**
 * Validate if user has required role
 * @param userRole - User's role from API
 * @param allowedRoles - Array of allowed roles
 * @returns boolean
 */
export function validateUserRole(
  userRole: string,
  allowedRoles: string[]
): boolean {
  return allowedRoles.includes(userRole);
}

/**
 * Validate if user has organization access
 * @param userOrgId - User's organization ID from API
 * @param requiredOrgId - Required organization ID (optional)
 * @returns boolean
 */
export function validateOrganizationAccess(
  userOrgId: number,
  requiredOrgId?: string,
  permittedAnalyticsSchoolIds: readonly string[] = []
): boolean {
  // If no organization ID required, grant access
  if (!requiredOrgId) {
    return true;
  }

  if (userOrgId === null || userOrgId === undefined) return false;

  // Check if user's organization matches required organization
  return userOrgId.toString() === requiredOrgId || permittedAnalyticsSchoolIds.includes(requiredOrgId);
}
